export default __webpack_public_path__ + "static/media/spot-catlike-final.ba523f78.mp4";